import { AfterViewInit, Component, ElementRef, inject, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';

import { DialogBaseComponent } from '../../../shared/dialogs/dialog-base.component';
import { Feedback } from '../../../shared/services/feedback.service';

@Component({
  selector: 'app-feedback-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './feedback-dialog.component.html',
  styleUrl: './feedback-dialog.component.scss'
})
export class FeedbackDialogComponent extends DialogBaseComponent implements AfterViewInit {
  contentInput = viewChild('contentInput', { read: ElementRef });

  private formBuilder = inject(FormBuilder);
  form = this.formBuilder.group({
    type: ['Suggestion', Validators.required],
    content: ['', Validators.required],
    contact: [true]
  });

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.contentInput()?.nativeElement.focus();
    });
  }

  onSendFeedback() {
    const results = this.form.value as Feedback;
    this.complete(results);
  }
}
